export default {
  computed: {
    isEditPage() {
      return this.$route.name === 'template-edit'
    },
    isDetailPage() {
      return this.$route.name === 'template-details'
    },
    isTemplatePage() {
      return this.$route.name.includes('template')
    },
  },
}
